/*
 * @Author: your name
 * @Date: 2021-05-21 10:20:08
 * @LastEditTime: 2022-02-28 19:11:00
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \ylfront-th-pudo\src\store\module\base.js
 */
/*
 * @Author: wanglikun
 * @Description: 基础信息
 */
import {searchMessageApi} from "@/@public/api";

const lang = localStorage.getItem("lang") || "EN";

// 获取本地国际化json
const langJsonStr = localStorage.getItem(`LangJson${lang}`) || "";
const langJson = (langJsonStr && JSON.parse(langJsonStr)) || {};

export default {
  state: {
    user: JSON.parse(localStorage.getItem("userData")) || null, // 用户信息
    token: localStorage.getItem("YL_WEB_TOKEN") || "", // token
    // token: localStorage.getItem('YL_NU_TOKEN') || 'eyJhbGciOiJIUzUxMiJ9.eyJzeXNDb2RlIjoiQURNSU4iLCJzZXNzaW9uSUQiOiJkOTI5ZTQ5MWRiNjY0NDQxYjFiNjcwMWMwNjM1YTYyYiIsImV4cCI6MTYyMjcwMjc2NiwiaWF0IjoxNjIyNjE2MzY2LCJ1cHNVc2VyIjoie1wiaWRcIjo0LFwiaXNFbmFibGVcIjoxLFwic3lzQ29kZVwiOlwiQURNSU5cIixcInVzZXJDb2RlXCI6XCIwMDM1MTk2NlwiLFwidXNlckZsYWdcIjoxLFwidXNlck5hbWVcIjpcIumCk-iAgFwifSJ9.dPUwZ_VFGwY7CRTF1SJ9qz8UFaLKkvdtdxCNkL5NL-s8OaTO22mNIdHvNLrzeOdYzgNl9ouf5lrGsSpNwf1hRw',
    lang, // 国际化配置
    langJson, // 当前国际化JSON对象
    langList: [], // 国际化语言列表，后端获取
    tableHeight: 0, // 高度计算 avue curd中使用
    setStation: {
      print: '',
      printer: '',
      template: 1,
      language: 'CN',
      isShowLogo: true
    },
    lodopStatus: false,
    messageStatus: false,
    notifyNum: 0,
    pendingCountData: [],
    printerList: []
  },
  mutations: {
    // 用户信息
    SET_USER: (state, data) => {
      state.user = data;
      localStorage.setItem("userData", JSON.stringify(data));
    },
    // 用户token
    SET_TOKEN: (state, data) => {
      state.token = data;
      localStorage.setItem("YL_WEB_TOKEN", data);
    },
    // table高度
    SET_TABLE_HEIGHT: (state, data) => {
      state.tableHeight = data;
    },
    // 设置国际化
    SET_LANG: (state, data) => {
      if (data !== state.lang) {
        localStorage.setItem("lang", data);
        state.lang = data;
        location.reload();
      }
    },
    // 本地lang
    SET_DEFAULT_LANG: (state, data) => {
      localStorage.setItem("lang", data);
      state.lang = data;
    },
    // 设置国家语言列表
    SET_LANG_LIST: (state, data) => {
      state.langList = data;
    },
    // 本地langjson 数据
    SET_LANG_JSON: (state, data) => {
      state.langJson = data;
      localStorage.setItem(`LangJson${state.lang}`, JSON.stringify(data));
    },
    // 退出
    LOGIN_OUT: (state) => {
      // 退出登录，清楚本地缓存
      localStorage.removeItem("userData");
      localStorage.removeItem("YL_WEB_TOKEN");
      //   localStorage.removeItem("tagListView");
      localStorage.removeItem("menuList");
      state.token = "";
      state.user = {};
      state.menuList = [];
    },
    // 站点设置
    SET_STATION: (state, data) => {
      console.log(data)
      state.setStation = data;
    },
    /* 判断打印机状态 */
    SET_LODOPSTATUS: (state, data) => {
      state.lodopStatus = data
    },
    /* 设置打印模块，打印回执操作专用 */
    SET_TEMPLATE: (state, data) => {
      state.setStation.template = data
    },
    SET_STATUS: (state, data) => {
      state.messageStatus = data;
    },
    SET_NOTIFY_NUM: (state, data) => {
      state.notifyNum = data;
    },
    PENDING_COUNT_DATA: (state, data) => {
      state.pendingCountData = data;
    },
    /* 打印机列表 */
    PRINTER_LIST: (state, data) => {
      state.printerList = data;
    }
  },
  actions: {
    // 登录初始化
    LOGIN_INIT({ commit } = {}, value) {
      const { user, token } = value;
      commit("SET_USER", user);
      commit("SET_TOKEN", token);
    },
    // 退出
    LOGIN_OUT({ commit } = {}) {
      commit("LOGIN_OUT");
    },
    // 窗口变化
    setTableHeight: ({ commit } = {}, value) => {
      commit("SET_TABLE_HEIGHT", value);
    },
    SET_STATION: ({ commit } = {}, value) => {
      console.log(111)
      commit("SET_STATION", value)
    },
    SET_LODOPSTATUS: ({ commit }, value) => {
      commit('SET_LODOPSTATUS', value)
    },
    /* 设置打印模块，打印回执操作专用 */
    SET_TEMPLATE: ({ commit }, value) => {
      commit('SET_TEMPLATE', value)
    },
    /* 获取通知数量*/
    GET_NOTIFICATION: async ({ commit }, value = 0) => {
      const { code, succ, data: { records, total }} = await searchMessageApi.reqList();
      if (code === 1 && succ) {
        commit('PENDING_COUNT_DATA', records)
        commit('SET_STATUS', total !== 0 || value)
        commit('SET_NOTIFY_NUM', total)
      } else {
        commit('SET_STATUS', false)
      }
    }
  },
  getters: {
    token: (state) => state.token || "",
    user: (state) => state.user || { name: "" },
    lang: (state) => state.lang,
    tableHeight: (state) => state.tableHeight,
    setStation: (state) => state.setStation,
    lodopStatus: (state) => state.lodopStatus,
    messageStatus: (state) => state.messageStatus,
    notifyNum: (state) => state.notifyNum,
    pendingCountData: (state) => state.pendingCountData
  }
};
